var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgred(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 551,
    viewBox: "0 0 1920 551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "image_20_",
    "data-name": "image (20)",
    width: 1920,
    height: 551,
    transform: "translate(2171 -6356)",
    fill: "#991010"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_484",
    x: 276.5,
    y: -445.5,
    width: 1028,
    height: 1028,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -26,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_485",
    x: 226.5,
    y: -492.5,
    width: 668,
    height: 668,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 26,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_486",
    x: -282.5,
    y: 111.5,
    width: 668,
    height: 668,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -26,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_487",
    x: 1531.5,
    y: -445.5,
    width: 668,
    height: 668,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -26,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_482",
    x: 345.5,
    y: -129.5,
    width: 1310,
    height: 1310,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: -26,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.5,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.31
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_23",
    "data-name": "Mask Group 23",
    transform: "translate(-2171 6356)",
    opacity: 0.8,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "image_20_2",
    "data-name": "image (20)",
    width: 1920,
    height: 715,
    transform: "translate(2171 -6520)",
    fill: "#991010"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2171, -6356)",
    filter: "url(#Ellipse_484)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_484-2",
    "data-name": "Ellipse 484",
    cx: 410.5,
    cy: 410.5,
    r: 410.5,
    transform: "translate(380 -316)",
    fill: "#991010"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2171, -6356)",
    filter: "url(#Ellipse_485)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_485-2",
    "data-name": "Ellipse 485",
    cx: 230.5,
    cy: 230.5,
    r: 230.5,
    transform: "translate(330 -415)",
    fill: "#991010"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2171, -6356)",
    filter: "url(#Ellipse_486)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_486-2",
    "data-name": "Ellipse 486",
    cx: 230.5,
    cy: 230.5,
    r: 230.5,
    transform: "translate(-179 241)",
    fill: "#991010"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2171, -6356)",
    filter: "url(#Ellipse_487)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_487-2",
    "data-name": "Ellipse 487",
    cx: 230.5,
    cy: 230.5,
    r: 230.5,
    transform: "translate(1635 -316)",
    fill: "#991010"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 2171, -6356)",
    filter: "url(#Ellipse_482)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_482-2",
    "data-name": "Ellipse 482",
    cx: 551.5,
    cy: 551.5,
    r: 551.5,
    transform: "translate(449)",
    fill: "#991010"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_808",
    "data-name": "Group 808",
    transform: "translate(-412 1268)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-2",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-3",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-4",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3351 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-5",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3386 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-6",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3421 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-7",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3456 -7661)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-8",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-9",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-10",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-11",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3351 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-12",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3386 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-13",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3421 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-14",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3456 -7631)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-15",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-16",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-17",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-18",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3351 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-19",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3386 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-20",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3421 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-21",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3456 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-22",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-23",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-24",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-25",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3351 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-26",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3386 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-27",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3421 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-28",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3456 -7571)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_809",
    "data-name": "Group 809",
    transform: "translate(-5154 -9299) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-29",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-30",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-31",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-32",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3351 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-33",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3386 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-34",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3421 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-35",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3456 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-36",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-37",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-38",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-39",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3351 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-40",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3386 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-41",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3421 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-42",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3456 -7571)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_810",
    "data-name": "Group 810",
    transform: "translate(-3709 -9408) rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-43",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-44",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-45",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-46",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3246 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-47",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3281 -7571)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_488-48",
    "data-name": "Ellipse 488",
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(3316 -7571)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgred);
export default __webpack_public_path__ + "static/media/bgred.b09c2f4f94848670aeecba5665559230.svg";
export { ForwardRef as ReactComponent };